import Bricks from 'bricks.js';
import { $ } from 'src/shared/js/utils/dom';

export default class WaterfallColumns {
  constructor(options = {}) {
    this.container = options.container;
    this.items = options.items;
    this.mediaQueries = options.mediaQueries
      ? options.mediaQueries
      : [{ columns: 3, gutter: 0 }];
  }

  updateWaterfall() {
    // update waterfall
    this.mason.pack();
  }

  setPlaceholderHeight() {
    this.items.forEach(item => {
      const placeholder = $('.image-gallery-placeholder', item);

      if (placeholder) {
        const imageSize = $('[data-size]', item).dataset.size;

        const sizes = imageSize.split('x');
        const ratio = parseInt(sizes[0]) / parseInt(sizes[1]);
        placeholder.style.paddingTop = (1 / ratio) * 100 + '%';
      }
    });
  }

  initMason() {
    this.mason = Bricks({
      container: this.container,
      sizes: this.mediaQueries,
      position: true,
      packed: 'packed',
    })
      .pack()
      .resize(true);
    window.addEventListener('resize', () => this.mason.pack(), {
      passive: true,
    });
  }

  init() {
    if (!this.container) {
      console.error(
        `Please pass a valid container. Container is '${this.container}'`
      );
      return;
    }

    this.setPlaceholderHeight();
    this.initMason();
  }
}
